/** Attach only after React has mounted the video; stop delayed streams on close. */
export async function attachCamera(
  stream: MediaStream,
  videoElement: () => HTMLVideoElement | null,
  isActive: () => boolean,
): Promise<HTMLVideoElement | undefined> {
  for (let attempt = 0; attempt < 30 && isActive(); attempt += 1) {
    const video = videoElement();
    if (video) {
      video.srcObject = stream;
      await video.play();
      if (isActive()) return video;
      break;
    }
    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
  }
  stream.getTracks().forEach((track) => track.stop());
  return undefined;
}

export function cameraErrorMessage(error?: unknown): string {
  if (!globalThis.isSecureContext) return 'La caméra nécessite une connexion HTTPS. Vous pouvez prendre une photo ou importer un fichier.';
  if (error instanceof Error && error.name === 'NotAllowedError') return 'Autorisez la caméra dans les réglages de ce site, puis réessayez. L’import d’une photo reste disponible.';
  if (error instanceof Error && error.name === 'NotFoundError') return 'Aucune caméra détectée. Importez une photo ou saisissez le code.';
  return 'La caméra n’a pas pu démarrer. Fermez les autres applications qui l’utilisent et réessayez, ou importez une photo.';
}
